import React, {useEffect, useState} from 'react';
import { useHistory, useRouteMatch } from "react-router-dom"
import createPersistedState from 'use-persisted-state';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button
} from 'reactstrap';
import clsx from 'clsx';
import { useTranslation } from "react-i18next";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import { getDisplayName } from '../utils'
import LoginForm from '../components/LoginForm'
import SignUpFormContainer from '../components/SignUpForm'
import { SET_SHIELD_TYPE } from "../context/editor";
import ForgotPasswordFormContainer from "../components/ForgotPasswordForm";
import FileSendIcon from "../images/pdf/file-send.svg";

const AuthStateContext = React.createContext();
const AuthDispatchContext = React.createContext();
const useAuthPersistedState = createPersistedState('auth');


const publicUrls = ['/login', '/signup', '/forgot-password', '/new-signup']

function AuthProvider({children}) {
  const [auth, setAuth] = useAuthPersistedState({});
  const [authModal, setAuthModal] = useState({});

  // useEffect(() => {
  //   if (auth?.token && auth?.redirectToHome) {
  //       history.replace(history.location.pathname);
  //       setStatus('')
  //   }
  // }, [auth, history])

  const openAuthModal = ({ type,  onLoginSuccess = () => {}, onSignUpSuccess, data }) => {
    setAuthModal({ type, data, onLoginSuccess: async (data) => {
      setAuthModal({})
      console.log({here: true, data })
      await onLoginSuccess(data)
    }, onSignUpSuccess: async (data) => {
      setAuthModal({})
      await onSignUpSuccess(data)
    } })
  }


  return (
    <AuthStateContext.Provider value={{...auth, hasAccount: !!auth?.accessToken, openAuthModal }}>
      <AuthDispatchContext.Provider value={setAuth}>
        {/* { status === 'redirecting' ? 
          <AccountRedirect /> : children
        }  */}
        {children}
        <AuthModal open={authModal.type?.length} initialType={authModal.type} onLoginSuccess={authModal.onLoginSuccess}  onSignUpSuccess={authModal.onSignUpSuccess} data={authModal.data} onClose={() => setAuthModal({ type: '' })} />
      </AuthDispatchContext.Provider>
    </AuthStateContext.Provider>
  )
}

function useAuthState() {
  const context = React.useContext(AuthStateContext)
  if (context === undefined) {
    throw new Error('useAuthState must be used within a AuthProvider')
  }
  return context
}

function useAuthDispatch() {
  const context = React.useContext(AuthDispatchContext)
  if (context === undefined) {
    throw new Error('useAuthDispatch must be used within a AuthProvider')
  }
  return context
}

function useAuth() {
  return [useAuthState(), useAuthDispatch()]
}

export { AuthProvider, useAuth, useAuthState, useAuthDispatch }

const determineTitle = ({type, email}) => {
  if (type === 'verify-account') return 'Te hemos enviado un correo de confirmación';
  if (type === 'login') return 'auth.login';
  if (type === 'forgotPassword') return 'auth.forgotPassword';
  return 'auth.signup'
}

const AuthModal = (props) => {
const {
  initialType = "login",
  open = false,
  className,
  onLoginSuccess,
  onSignUpSuccess,
  onClose,
  data,
} = props;
const { t } = useTranslation('common')
const [isOpen, setIsOpen] = useState(open);
const [type, setType] = useState(initialType);
const [email, setEmail] = useState('');

const toggle = () => { 
    setIsOpen(!isOpen);
    if (isOpen) onClose();
};
const handleSignUpSuccess = async (data) => {
  if (onSignUpSuccess) {
      await onSignUpSuccess(data)
  }
  //setType('verify-account')
  console.log({data})
  setEmail(data.email)
}

useEffect(() => {
    setIsOpen(open)
}, [open])
useEffect(() => {
    setType(initialType)
}, [initialType])

console.log({type})

return (
    <Modal isOpen={isOpen} toggle={toggle} className={className}>
      <ModalHeader toggle={toggle}>
          {t(determineTitle({ type, email }))}
      </ModalHeader>
      <ModalBody>
          {
              type === 'login' ? 
                  <LoginForm onForgotPassword={() => setType('forgotPassword')} onLoginSuccess={onLoginSuccess}  onGoToSignup={() => setType('signup')} payload={data}   />
              : type === 'forgotPassword' ?
                  <ForgotPasswordFormContainer onGoToLogin={() => setType('login')} />
              : type === 'verify-account' ?
                  <div className="media-body">
                      <div className="text-center">
                          {/* <h4 className="font-weight-bold mb-4 text-center">{t('Te hemos enviado un correo de confirmación')}</h4> */}
                          <div>
                              <span className="text-center text-muted mb-4 text-center">{t('Confirma tu cuenta dando click en el correo enviado a {{email}}', { email: email })}</span>
                          </div>
                          <div>
                              <img className="m-1 mb-2 p-1" src={FileSendIcon} style={{width: 120}} />
                          </div>
                          {/* <div className="p-2"><strong>¿No lo has recibido?</strong></div> */}
                          {/* <button data-action="signup" type="button" className="btn btn-sm btn-primary" onClick={handleResendVerificationCode}>{t('demoForm.resendVerify')}</button> */}
                      </div>
                  </div>
              : type === 'signup' ? <SignUpFormContainer onSignUpSuccess={handleSignUpSuccess} onGoToLogin={() => setType('login')} payload={data} />
              : null
          }
        
      </ModalBody>
    </Modal>
);
}
